export default __webpack_public_path__ + "f39015c05101ce86bb21ac7f11645552.svg";